import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const UserIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "currentColor",
    width: size || "28",
    height: size || "28"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "14",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 0c7.732 0 14 6.28 14 14.026 0 3.56-1.323 6.81-3.504 9.282l-.177.198a11.816 11.816 0 0 0-10.386-6.203c-4.684 0-8.758 2.257-10.652 5.747A13.984 13.984 0 0 1 0 14.026C0 6.28 6.268 0 14 0zm.345 5.027a5.39 5.39 0 0 0-5.385 5.395 5.39 5.39 0 0 0 5.385 5.395 5.39 5.39 0 0 0 5.384-5.395 5.39 5.39 0 0 0-5.384-5.395z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0zm0 1.12C6.887 1.12 1.12 6.887 1.12 14S6.887 26.88 14 26.88 26.88 21.113 26.88 14 21.113 1.12 14 1.12z"
  })));
};
UserIcon.displayName = 'UserIcon';
export default UserIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UserIcon.js.map